module.exports = __webpack_public_path__ + "img/img1.7f4e3884.png";